import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXTimePicker from "../../../../../Components/Inputs/BMXTimePicker/BMXTimePicker";
import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import "./TenderFormStepOne.scss"
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import { useDispatch } from "react-redux";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
import { show } from "redux-modal";
import moment from "moment";

const TenderFormStepOne = (props) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [contacts, setContacts] = useState([]);

  const { values, form } = props;

  const getSelectedContact = (contact) => {
    if (!contact) return null;
    return contacts.find(
      (el) => el.uuid === contact.value || el.uuid === contact.uuid
    );
  };

  const getData = async (searchTerm) => {
    if (searchTerm?.length > 0) {
      const data = GlobalAuthFetch({
        path: `/contact/findByName/${searchTerm}`,
      });
      const [contactListPayload] = await Promise.all([data]);
      const contactList = contactListPayload?.payload?.data?.map((contact) => {
        return {
          uuid: contact.uuid,
          value: `${contact.name}`,
          ...contact,
        };
      });

      if (contactList?.length > 0) {
        setContacts(contactList);
        return contactList;
      } else {
        setContacts([]);
        return [];
      }
    }
  };

  useEffect(()=>{
    if(values?.deadline){
      form.change("deadlineDate",moment(values?.deadline).startOf("day"));
      form.change("deadlineTime",values?.deadline);
      form.change("deadline",null);
    }
  },[values?.deadline])

  return (
    <div className="TenderFormStepOne" style={{ justifyContent: "space-between" }}>
      <BMXSeparator title={t("global:tender.tenderData")} />
      <Row>
        <Col xs={6}>
          <Field
            name="caseNumber"
            label={`${t("global:tender.caseNumber")}*`}
            component={BMXTextField}
            data-cy="caseNumber"
          />
        </Col>
        <Col xs={{ offset: 2, span: 4 }}>
          <Field
            name="deadlineDate"
            label={`${t("global:tunder.deadlineDate")}*`}
            component={BMXDatePicker}
            data-cy="deadlineDate"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={{ offset: 8, span: 4 }}>
          <Field
            name="deadlineTime"
            component={BMXTimePicker}
            noSetTime
            label={t("global:tunder.deadlineTime")}
            data-cy="deadlineTime"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={{ span: 6 }}>
          <Field
            currentValues={values}
            className="contractor"
            component={BMXAsynchronous}
            getOptionLabel={(option) => {
              if (option.name) return option.name;
              return option;
            }}
            label={`${t("global:tender.contractor")}*`}
            name="contractor"
            options={contacts}
            // disabled={update}
            getData={getData}
            data-cy="client"
            disablePortal={true}
            onClose={() => {
              form.change("representative", null);
            }}
          />
        </Col>

        <Col xs={{ span: 6 }}>
          <Field
            data-cy="representative"
            beforeIcon="people"
            afterIcon="add"
            afterIconSize="18px"
            afterIconClick={() => {
              const contactUuid =
                values?.contractor?.uuid || values?.contractor?.value;
              const updateSingleRegistry = () =>
                updateDashboardByName("contact", contactUuid);
              dispatch(
                show("RepresentativesModal", {
                  loadData: async () => {
                    await getData(values?.contractor?.name);
                  },
                  header: t("global:document.representativeAdd"),
                  updateSingleRegistry,
                  uuid: contactUuid,
                })
              );
            }}
            disabled={!values?.contractor}
            component={BMXSelectField}
            values={getSelectedContact(values?.contractor)?.representatives?.map(
              (el) => ({
                value: el.uuid,
                name: `${el.name || ""} ${el.lastname || ""}`,
              })
            )}
            label={`${t("global:document.representative")}`}
            name="representative"
            renderValue={(el) => {
              return `${el.name || ""} ${el.lastname || ""}`;
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Field
            name="link"
            label={`${t("global:tender.link")}`}
            component={BMXTextField}
            data-cy="link"
          />
        </Col>
      </Row>
    </div>
  );
};

export default TenderFormStepOne;
